/**
 * Welche Toene ein neuer Spielstand ausloest (15.10.2026).
 *
 * Der Client bekommt vom Server keine Ereignisliste - er vergleicht deshalb
 * den neuen Stand mit dem vorigen. Das reicht voellig: Ein Treffer ist ein
 * gesunkener Lebensbalken, ein Aufstieg ein hoeheres Level.
 *
 * GENAU DARIN LAG EIN FEHLER (Rueckmeldung vom 15.10.2026): "Wenn ich im
 * Menue Back druecke, kommt immer so ein komischer Ton - der, der auch kommt,
 * wenn ein Creep in mein Anchor laeuft." Verlaesst man ein Match, faellt der
 * Schnappschuss auf den leeren zurueck, und darin steht das Portal bei null.
 * Der Vergleich sah 100 -> 0 und spielte folgerichtig den Portalton.
 *
 * Deshalb steht der Vergleich jetzt hier und nicht mitten in einem Effekt:
 * So laesst sich pruefen, dass beim Verlassen nichts toent - und beim
 * naechsten Match auch nicht der Sprung zurueck.
 */

import type { SoundName } from '../audio/Sound.js';

/** Was vom vorigen Stand gemerkt wird. */
export interface TonGedaechtnis {
  level: number;
  portalHp: number;
  noticeId: number;
}

export interface TonEingabe {
  level: number;
  portalHp: number;
  /** Die letzte Rueckmeldung des Servers - null, wenn es keine gibt. */
  notice: { id: number; kind: string } | null;
  /**
   * Ist gerade ueberhaupt ein Match zu sehen?
   *
   * Im Menue und im Warteraum bleibt es still. Dort sagt ein Vergleich
   * nichts ueber das Spiel aus - er vergleicht zwei Welten.
   */
  sichtbar: boolean;
}

export interface TonErgebnis {
  toene: SoundName[];
  /** Was sich der Aufrufer fuer das naechste Mal merken muss. */
  gedaechtnis: TonGedaechtnis;
}

/**
 * Vergleicht zwei Staende und sagt, was zu hoeren ist.
 *
 * Das Gedaechtnis wird AUCH DANN fortgeschrieben, wenn nichts toent. Sonst
 * traefe den naechsten Vergleich der Sprung, den dieser gerade verschluckt
 * hat - beim Verlassen von hundert auf null, beim naechsten Match von null
 * auf hundert.
 */
export function matchToene(vorher: TonGedaechtnis, jetzt: TonEingabe): TonErgebnis {
  const gedaechtnis: TonGedaechtnis = {
    level: jetzt.level,
    portalHp: jetzt.portalHp,
    noticeId: jetzt.notice?.id ?? vorher.noticeId,
  };

  if (!jetzt.sichtbar) return { toene: [], gedaechtnis };

  const toene: SoundName[] = [];

  // Level 0 gibt es nicht - der Stand davor war also noch keiner.
  if (jetzt.level > vorher.level && vorher.level > 0) toene.push('level');
  if (jetzt.portalHp < vorher.portalHp) toene.push('portal');

  if (jetzt.notice && jetzt.notice.id !== vorher.noticeId) {
    toene.push(jetzt.notice.kind === 'error' ? 'denied' : 'buy');
  }

  return { toene, gedaechtnis };
}
